export const brandViolet = "#291C6E"
export const brandPink = "#E0246C"
export const brandPinkTransparent = "rgba(224, 36, 108, 0.8)"
export const lightViolet = "#635995"
export const lightPink = "#E85F94"
export const linkGray = "#4a4a4a"

export const gray = "#8C8E9B"
export const lightGray = "#9eabb3"
export const fadedBlack = "#4a4a4a"
